import React from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';

const StyledPageWrapper = styled(motion.div)`
  width: 100%;
  position: relative;
`;

const variants = {
  initial: { opacity: 0 },
  animate: { 
    opacity: 1,
    transition: {
      duration: 0.3,
      ease: [0.43, 0.13, 0.23, 0.96],
      when: "beforeChildren"
    }
  },
  exit: { 
    opacity: 0,
    transition: {
      duration: 0.2,
      ease: [0.43, 0.13, 0.23, 0.96],
      when: "beforeChildren"
    }
  }
};

const PageWrapper = ({ children }) => {
  return (
    <StyledPageWrapper
      variants={variants}
      initial="initial"
      animate="animate"
      exit="exit"
      mode="wait"
    >
      {children}
    </StyledPageWrapper>
  );
};

export default PageWrapper;
